import styled from 'styled-components'
import css from '@styled-system/css'
import { FacebookShareButton } from 'react-share'

export const FacebookShareButtonBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
`

export const ShareButton = styled(FacebookShareButton)`
  ${css({
    p: 4,
    fontSize: 1,
    borderRadius: 'small',
    borderWidth: 0,
    fontWeight: 'bold',
    fontFamily: 'base',
    color: 'white',
  })}
  width: 100%;
  background-color: rgb(59, 89, 152);
  cursor: pointer;
`
